var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpread(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M33 13.17L35.83 16M33 18.83L35.83 16M15.5 10.84L14 8.25 9.5.5m12 10.33L27.5.5M2.33 16h6m26.5 0H24.5m-.86-14.64L27.55.5m.86 3.91L27.55.5m-14.14.86L9.51.5m-.86 3.91L9.51.5m12.05 20.67l.19.33 5.81 10M15.5 21.26L9.56 31.5m3.85-.86l-3.9.86m-.86-3.91l.86 3.91m14.17-.86l3.91.86m.86-3.91l-.86 3.91M3.33 18.83L.5 16m2.83-2.83L.5 16m21 5.2a6 6 0 113-5.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpread);
export default __webpack_public_path__ + "static/media/spread.a6a16acf45aa8ba31a8206e9fc0d50f6.svg";
export { ForwardRef as ReactComponent };